import { Injectable } from "@angular/core";
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ResponseParserService {

  findNavTabModel(model: any, navTabNumber: number): any {
    return model?.form?.tabs?.[`tab${navTabNumber}`];
  }

  findPageModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number): any {
    const isTryingToFindRepeatingPageItem = pageIndex !== null && pageIndex !== undefined;
    return isTryingToFindRepeatingPageItem
      ? this.findNavTabModel(model, navTabNumber)?.[`page${pageNumber}`]?.[pageIndex]
      : this.findNavTabModel(model, navTabNumber)?.[`page${pageNumber}`];
  }

  findSectionModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number, sectionCode: string, sectionIndex: number): any {
    const isTryingToFindRepeatingSectionItem = sectionIndex !== null && sectionIndex !== undefined;
    return isTryingToFindRepeatingSectionItem
      ? this.findPageModel(model, navTabNumber, pageNumber, pageIndex)?.[sectionCode]?.[sectionIndex]
      : this.findPageModel(model, navTabNumber, pageNumber, pageIndex)?.[sectionCode];
  }

  findQuestionModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number, sectionCode: string, sectionIndex: number, questionCode: string) {
    return this.findSectionModel(model, navTabNumber, pageNumber, pageIndex, sectionCode, sectionIndex)?.[questionCode];
  }

  replaceNavTabModel(model: any, navTabNumber: number, newNavTabModel: any): boolean {
    const navTabParentModel = model?.form?.tabs;
    if (navTabParentModel) {
      navTabParentModel[`tab${navTabNumber}`] = newNavTabModel;
      return true;
    }
    return false;
  }

  replacePageModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number, newPageModel: any): boolean {
    const pageParentModel = this.findNavTabModel(model, navTabNumber);
    if (pageParentModel) {
      const isTryingToReplaceRepeatingPageItem = pageIndex !== null && pageIndex !== undefined;
      if (isTryingToReplaceRepeatingPageItem) {
        const pageItemParentModel = pageParentModel[`page${pageNumber}`];
        if (pageItemParentModel) {
          pageItemParentModel[pageIndex] = newPageModel;
          return true;
        }
      }
      else {
        pageParentModel[`page${pageNumber}`] = newPageModel;
        return true;
      }
    }
    return false;
  }

  replaceSectionModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number, sectionCode: string, sectionIndex: number, newSectionModel: any): boolean {
    const sectionParentModel = this.findPageModel(model, navTabNumber, pageNumber, pageIndex);
    if (sectionParentModel) {
      const isTryingToReplaceRepeatingSectionItem = sectionIndex !== null && sectionIndex !== undefined;
      if (isTryingToReplaceRepeatingSectionItem) {
        const sectionItemParentModel = sectionParentModel[sectionCode];
        if (sectionItemParentModel) {
          sectionItemParentModel[sectionIndex] = newSectionModel;
          return true;
        }
      }
      else {
        sectionParentModel[sectionCode] = newSectionModel;
        return true;
      }
    }
    return false;
  }

  replaceQuestionModel(model: any, navTabNumber: number, pageNumber: number, pageIndex: number, sectionCode: string, sectionIndex: number, questionCode: string, newQuestionModel: any): boolean {
    const questionParentModel = this.findSectionModel(model, navTabNumber, pageNumber, pageIndex, sectionCode, sectionIndex);
    if (questionParentModel) {
      questionParentModel[questionCode] = newQuestionModel;
      return true;
    }
    return false;
  }

  updateModel(baseForm: any, tabNumber: number, pageNumber: number, pageIndex: number, section: string, model: any, triggerModelChanged = true) {
    let copy = { ...baseForm.model };
    Object.keys(model).forEach(prop => {
      const path = ['form', 'tabs', 'tab' + tabNumber, 'page' + pageNumber];
      if (pageIndex > -1) {
        path.push('' + pageIndex);
      }
      path.push(section);
      path.push(prop);
      _.set(copy, path, model[prop]);
    });
    baseForm.model = copy;

    if (triggerModelChanged) {
      baseForm.modelChanged();
    }
  }
}
